import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"
import { alpha } from "@mui/material"

export const useStyles = makeStyles()(({ spacing, palette, shadows }) => ({
  sortIcon: {
    fontSize: "0.75rem",
    color: blueGrey[400],
    cursor: "pointer"
  },
  activeSortIcon: {
    color: blueGrey[800]
  },
  activeActionIcon: {
    color: lightBlue[500],

    "&:focus": {
      border: "none",
      outline: `1px solid ${lightBlue[400]}`,
      boxShadow: `0 0 0 3px ${alpha(lightBlue[200], 0.2)} !important`
    }
  },
  unactiveActionIcon: {
    color: blueGrey[300]
  },
  tableWrapper: {
    minWidth: "315px",
    marginTop: spacing(4)
  },
  tableHeader: {
    padding: `${spacing(1, 2, 2)} 38px`,
    borderBottom: `2px solid ${blueGrey[200]}`
  },
  tableBody: {
    height: "300px",
    overflow: "auto",
    border: `1px solid ${blueGrey[200]}`
  },
  tableBodyOver: {
    border: `1px solid ${lightBlue[300]}`
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    padding: spacing(1),
    cursor: "pointer",
    border: `1px solid transparent`,

    "&:focus": {
      borderColor: lightBlue[300],
      outline: `3px solid ${alpha(lightBlue[200], 0.2)}`,
      boxShadow: "none !important"
    }
  },
  tableRowBackgroundColor: {
    "&:nth-child(odd)": {
      backgroundColor: alpha(blueGrey[50], 0.5)
    }
  },
  dragTableRow: {
    border: `1px solid ${lightBlue[400]}`,
    backgroundColor: palette.common.white,
    boxShadow: shadows[6],
    padding: spacing(2)
  },
  disabledRow: {
    color: blueGrey[500],

    "&:focus": {
      borderColor: "transparent",
      outline: "none"
    }
  },
  moveAllButtonWrapper: {
    display: "flex",
    alignItems: "center",
    padding: spacing(1),
    borderLeft: "2px solid transparent"
  },
  disabledMoveAll: {
    color: blueGrey[500]
  }
}))
